<button class="scroll-to-top" [ngClass]="{active:windowScrolled}" (click)='scrollToTop()' aria-label="Scroll To Top">
    <div class="arrow"></div>
</button>